
import http from "../http-common";

class CalibrationService {
  getAll() {
    return http.get("/calibrations");
  }

  getAllFull() {
    return http.get("/calibrations/full");
  }

  get(calibrationID) {
    return http.get(`/calibrations/${calibrationID}`);
  }

  getLolCalibrations(lolID) {
    return http.get(`/calibrations/?lolid=${lolID}`);
  }

  getLolCalibrationsFull(lolID) {
    return http.get(`/calibrations/full/?lolid=${lolID}`);
  }

  create(data) {
    return http.post("/calibrations", data);
  }

  update(calibrationID, data) {
    return http.put(`/calibrations/${calibrationID}`, data);
  }

  delete(calibrationID) {
    return http.delete(`/calibrations/${calibrationID}`);
  }

  deleteAll() {
    return http.delete(`/calibrations`);
  }

  findByName(calibrationNumber) {
    return http.get(`/calibrations?calibrationnumber=${calibrationNumber}`);
  }
}

export default new CalibrationService();